export default __webpack_public_path__ + "eb86ab31094d2e7a9d631af781bf34ae.png";